import React, { useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import logo1 from "../Images/logo1.png";
import bgauth from "../Images/bg-auth.jpg";
import { errorToast } from "./ToastMessage";
import axios from "axios";
// import { dispatch } from "../reduxReducers/configureStore";
// import { setAuthData } from "../reduxReducers/slices/AuthSLice";

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const SignInPage = () => {
  const navigate = useNavigate();

  const handleLogin = useCallback(
    async (values, setSubmitting) => {
      try {
        const response = await axios.post("/auth/login", values);

        if (response?.data) {
          localStorage.setItem("authToken", response.data.token);
          // dispatch(setAuthData(response.data));
          navigate("/dashboard");
        }
      } catch (error) {
        errorToast(error.message);
      } finally {
        setSubmitting(false);
      }
    },
    [navigate]
  );

  // Using useFormik hook
  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      handleLogin(values, setSubmitting);
    },
  });

  return (
    <div
      className="flex justify-center items-center min-h-screen"
      style={{
        backgroundImage: `url(${bgauth})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="rounded-lg p-8 shadow-md w-full sm:max-w-lg backdrop-blur-2xl bg-green-50/50">
        <img src={logo1} alt="logo" className="mb-4" />
        <form className="space-y-4" onSubmit={formik.handleSubmit}>
          <div>
            <label className="block mb-2 font-semibold text-[#64748B]">
              Email: <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              className="border border-gray-300 rounded px-3 py-2 w-full"
            />
            {formik.touched.email && formik.errors.email && (
              <div className="text-red-500 text-sm">{formik.errors.email}</div>
            )}
          </div>
          <div>
            <label className="block mb-2 font-semibold text-[#64748B]">
              Password: <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              name="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              className="border border-gray-300 rounded px-3 py-2 w-full"
            />
            {formik.touched.password && formik.errors.password && (
              <div className="text-red-500 text-sm">
                {formik.errors.password}
              </div>
            )}
          </div>
          <div className="flex justify-center text-[#64748B]">
            <button
              type="submit"
              disabled={formik.isSubmitting}
              className="mt-2 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
            >
              {formik.isSubmitting ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </form>
        <p className="text-center text-lg text-black pt-3">
          Don't have an account?
          <Link
            className="text-slate-500 pl-1 font-semibold hover:text-slate-700"
            to="/signup"
          >
            Create now
          </Link>
        </p>
        <p className="text-center text-lg text-black pt-3">
          Already have an account?
          <Link
            className="text-slate-500 pl-1 font-semibold hover:text-slate-700"
            to="/forget-password"
          >
            Forgot password
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SignInPage;
